import * as React from "react";
import classNames from "classnames";
import { RuleGroup } from "./rule-group";
import type { IScope } from "reducers/scope";

interface IProps {
    scope: IScope;
    canEditGroupName: boolean;
    displayAllProducts: boolean;
    fields: any;
    filters: any;
    filterValues: any;
    groups: any;
    onAddRule: (event) => void;
    onAddValue: (event, options?) => void;
    onChangeGroupName: (groupId, value) => void;
    onFetchFilterValues?: (action, field, value, options?) => void;
    onResetFilterValues?: () => void;
    onRemoveGroup?: (event) => void;
    onRemoveRule: (event) => void;
    onRemoveValue: (groupId, ruleId, value) => void;
    onSelectField: (event) => void;
    onToggleGroupType?: (event) => void;
    onToggleRuleType?: (event) => void;
    onChangeExclude?: (groupId: string, exclude: boolean) => void;
}

export class RuleGroups extends React.PureComponent<IProps, any> {
    render() {
        const {
            scope,
            canEditGroupName,
            displayAllProducts,
            fields,
            filters,
            filterValues,
            groups,
            onAddRule,
            onAddValue,
            onChangeGroupName,
            onFetchFilterValues,
            onChangeExclude,
            onRemoveGroup,
            onRemoveRule,
            onRemoveValue,
            onResetFilterValues,
            onSelectField,
            onToggleGroupType,
            onToggleRuleType,
        } = this.props;

        return (
            <div className={classNames({ groups: true, hidden: displayAllProducts === true })}>
                {groups.map((group) => {
                    return (
                        <RuleGroup
                            canEditGroupName={canEditGroupName}
                            scope={scope}
                            fields={fields}
                            filters={filters}
                            filterValues={filterValues}
                            group={group}
                            key={group.get("_id")}
                            onAddRule={onAddRule}
                            onAddValue={onAddValue}
                            onChangeGroupName={onChangeGroupName}
                            onFetchFilterValues={onFetchFilterValues}
                            onChangeExclude={onChangeExclude}
                            onRemoveGroup={onRemoveGroup}
                            onRemoveRule={onRemoveRule}
                            onRemoveValue={onRemoveValue}
                            onResetFilterValues={onResetFilterValues}
                            onSelectField={onSelectField}
                            onToggleGroupType={onToggleGroupType}
                            onToggleRuleType={onToggleRuleType}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RuleGroups;
